<div class="container">
    <div class="single-column-layout">
        <h1>Consulting Engagements</h1>
        @if (isLoading) {
            <div class="text-center" style="margin-top: 50px; text-align: center;">
                <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
            </div>
        }
        @if (engagements.length === 0 && !isLoading) {
            <div class="text-center" style="margin-top: 50px; text-align: center;">
                There are currently no consulting engagements
            </div>
        }
        @if (!isLoading && engagements.length > 0) {
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>Company</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    @for (engagement of engagements; track engagement) {
                        <tr>
                            <td>
                                {{ engagement.name }}
                            </td>
                            <td style="width: 230px;">
                                @if (engagement.accepted === false) {
                                    <button (click)="openEngagementModal(engagement)"
                                            class="ace-btn btn-sm ace-btn btn-primary">
                                        Accept
                                    </button>
                                }
                                @if (engagement.accepted === false) {
                                    <button (click)="rejectInvitation(engagement)"
                                            class="ace-btn btn-sm ace-btn btn-primary">
                                        Reject Invite
                                    </button>
                                }
                                @if (engagement.accepted) {
                                    <button (click)="cancelEngagement(engagement)"
                                            class="ace-btn btn-sm ace-btn btn-primary">
                                        Cancel Engagement
                                    </button>
                                }
                                @if (engagement.accepted) {
                                    <button (click)="openEngagementModal(engagement)"
                                            class="ace-btn btn-sm ace-btn btn-primary">
                                        Edit
                                    </button>
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        }
    </div>
</div>
